import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { PROFILE_DATA_SERVICE, ProfileDataService } from '../../../services/profile/profile-data.service';
import { UserProfileShareService } from '../../../services/shared-service/user-profile-share.service';
import { RESOURCES_DATA_SERVICE, ResourcesDataService } from '../../../services/resources/resources-data.service';
import { ACTION_DATA_SERVICE, ActionDataService } from '../../../services/action/data.service';
import { Store } from '@ngxs/store';
import { AdminMandant } from '../../../models/cloud/cloud.model';
import { CLOUD_DATA_SERVICE, CloudDataService } from '../../../services/cloud/cloud-data.service';

@Component({
  selector: 'fi-administration',
  templateUrl: './administration.component.html',
  styleUrls: ['./administration.component.scss'],
  standalone: false,
})
export class AdministrationComponent implements OnInit {
  activeTab: number = 0;
  mandant?: AdminMandant;

  constructor(
    private readonly sharedProfileService: UserProfileShareService,
    @Inject(ACTION_DATA_SERVICE) public actionDataService: ActionDataService,
    @Inject(CLOUD_DATA_SERVICE) public cloudDataService: CloudDataService,
    private fb: UntypedFormBuilder,
    private store: Store
  ) {
    const subscription = sharedProfileService.getAdminMandant().subscribe((data) => {
      if (data) {
        this.mandant = data;
        setTimeout(() => {
          subscription?.unsubscribe();
        });
      }
    });
  }

  ngOnInit(): void {
  }

  onTabChange($event: number): void {
  }
}
